import React from 'react';
import { Link } from 'react-router-dom';
import PersonalInfoTab from '../components/PersonalInfoTab';

/**
 * 내 계정에 대한 것만 둔다.
 *
 * 권한 관리 탭이 여기 있었다. 남의 역할을 정하는 일은 내 설정이 아니고, 그
 * 명단은 사용자 화면에 이미 있다 -- 사람을 하나 더할 때마다 두 곳을 오가야
 * 했다. 사용자 화면으로 옮겼다.
 */
const SettingsPage = () => {
  return (
    <div className="settings-page pb-5" style={{ backgroundColor: '#f8f9fa', minHeight: '100vh' }}>
      {/* ... styles ... */}
      <style>{`
        /* ... existing styles ... */
        .settings-header {
          background-color: #fff;
          position: sticky;
          top: 0;
          z-index: 100;
        }
        .form-label {
          font-weight: 700;
          font-size: 0.95rem;
          margin-bottom: 0.5rem;
        }
        .form-control, .form-select {
          border-radius: 12px;
          padding: 0.75rem 1rem;
          border-color: #e2e8f0;
          background-color: #fff;
        }
        .form-control:focus, .form-select:focus {
          border-color: var(--primary-color);
          box-shadow: 0 0 0 3px rgba(79, 70, 229, 0.1);
        }
        .btn-toggle {
          padding: 0;
          border: none;
          background: none;
        }
        /* Toggle switch styles removed if unused, but keeping just in case */
      `}</style>
      <div className="settings-header px-3 pt-3 pb-2">
        <h4 className="fw-bold mb-0 py-2">설정</h4>
      </div>

      {/* Content Area */}
      <div className="mt-4 pb-5">

        <div className="settings-section">
          <PersonalInfoTab />
        </div>

        <div className="mt-5 pt-5 pb-3 text-center border-top">
          <p className="text-muted small mb-1">바로보고 (barobogo) v1.0.0</p>
          <Link to="/privacy" className="text-decoration-none text-primary small fw-bold">개인정보처리방침</Link>
        </div>
      </div>
    </div>
  );
};

export default SettingsPage;
